import React from "react";

import "./CardPerson.css";

const CardPerson = (props) => {
  return (
    <div className="person-card-wrapper">
      <div className="person-info">
        <p>{props.name}</p>
        <p>{props.position}</p>
        <p>{props.email}</p>
      </div>
      <img src={props.image} alt ={props.name} />
    </div>
  );
};

export default CardPerson;
